// extracted by mini-css-extract-plugin
export var component = "blog-header-module--component--2UIPR";
export var heading = "blog-header-module--heading--3Pt-r";